import { render } from "./cities-grid.vue?vue&type=template&id=03d32541"
import script from "./cities-grid.vue?vue&type=script&lang=js"
export * from "./cities-grid.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__